import { constants } from './showmore.constant'

import { createSelector } from '@/factory'

const getTargets = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.target }, true)

export const showMoreSelectors = {
	getTargets,
}
